import details from './details/state/main'

export default {
  namespaced: true,
  modules: {
    details
  }
}
